import * as React from 'react';
import type { SVGProps } from 'react';

const SvgPb = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={21} viewBox="0 0 48 48" {...props} fill={"currentColor"} fillRule={"evenodd"}>
    <path
      d="M34.824 42.4h-23.65A6.572 6.572 0 0 1 4.6 35.826V12.158a6.572 6.572 0 0 1 6.57-6.574h23.654a6.572 6.572 0 0 1 6.57 6.574v23.668a6.572 6.572 0 0 1-6.57 6.574Zm-6.19-6.3c3.074-.08 4.488-3.144 4.488-3.144.606-1.167.863-6.418 1.181-7.164.022-.031.048-.059.068-.091a.141.141 0 0 0-.068.091c-1.254 1.784-4.794 2.219-4.821 2.224l-.286 2.865c-.108 1.011-.672 1.113-1.463 1.127h-8.074L19.21 36.1h9.424Zm3.59-24.3H16.132a2.021 2.021 0 0 0-2.193 1.921C13.09 19.455 10.634 36.1 10.634 36.1h4.538l2.565-19.248a.943.943 0 0 1 1.052-.96c2.434 0 8.062.013 10.591 0 1.031 0 1.534.041 1.431 1.234a11.823 11.823 0 0 1-.6 3.288.978.978 0 0 1-1.18.817h-8.026l-.449 4.092h8.976a4.4 4.4 0 0 0 4.937-3.593l.9-5.838a3.413 3.413 0 0 0-3.144-4.092Z"
    />
  </svg>
);

export default SvgPb;
